module.exports = {
  model: { id: '', customers: [], recurrence: false },
  modelOccurrence: {id: '', service_id: '', driver_id: '', message: ''},
  modelObservation: {id: '', service_id: '', message: ''}
}
